import { render, staticRenderFns } from "./TipoPrestador.vue?vue&type=template&id=41fd98e0"
import script from "./TipoPrestador.vue?vue&type=script&lang=js"
export * from "./TipoPrestador.vue?vue&type=script&lang=js"
import style0 from "./TipoPrestador.vue?vue&type=style&index=0&id=41fd98e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports